Jelly.Payments.Update_Ticket_Forecast = function(Parameters)
{	
	// TODO - Notate Description & Inputs Up here
	
	// Get base values
	var Namespace = Parameters['Namespace'];	
	var Price = Jelly.jQuery('#' + Namespace + ' ' + 'input[name="Price"]').val();
	var Capacity = Jelly.jQuery('#' + Namespace + ' ' + '.Capacity .Input input').val();
	var Volunteers = Jelly.jQuery('#' + Namespace + ' ' + '.Volunteers .Input input').is(':checked');
	var Donations = Jelly.jQuery('#' + Namespace + ' ' + '.Donations .Input input').is(':checked');

	// Get additional values per kind
	 switch (Parameters['Kind'])
	 {
	 	case 'Suggested_Donation':
	 		var Suggested_Price = Jelly.jQuery('#' + Namespace + ' ' + 'input[name="Suggested_Price"]').val();
	 		break;
	 }
	 
	// Create forecast
	var Forecast = "";
	
	// Only create forecase if capacity > 0 and price > 0 
	if (Price && Capacity && Price != 0 && Capacity != 0)
	{
		// Calculate base revenue per kind
		switch (Parameters['Kind'])
		{
			case 'Suggested_Donation':
				// Calculate minimum + maximum donations
				var Minimum_Revenue = Price * Capacity;
				var Maximum_Revenue = Suggested_Price * Capacity;

				// Add donations to forecast
				Forecast = '$' + '<span class="Number">' + Math.round(Minimum_Revenue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '</span>' + '&mdash;' + '$' + '<span class="Number">' + Math.round(Maximum_Revenue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '</span>' + ' ' + 'in donations';
				break;

			case 'Ticketed_Event':
				// Calculate base revenue		
				var Base_Revenue = Price * Capacity;

				// Add base revenue to forecast
				Forecast = '$' + '<span class="Number">' + Math.round(Base_Revenue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '</span>' + ' ' + 'at sellout';
				break;
				
				if (Donations)
				{	
					// Calculate donor revenue 
					var Donor_Revenue = Price * Capacity * .15;			
			
					// Add donor revenue to forecast
					Forecast += ' + ' + '$' + '<span class="Number">' + Math.round(Donor_Revenue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '</span>' + ' ' + 'in donations';
				}
		}
		
		if (Volunteers)
		{
			// Calculate membership growth
			var Membership_Growth = Math.round(Capacity * .05);
			
			// Add membership growth to forecast			
			Forecast += ' + ' + '<span class="Number">' + Membership_Growth + '</span>' + ' ' + 'new member';
			if (Membership_Growth != 1) Forecast += 's';
		}
	}
				
	// Display forecast
	var Forecast_Element = Jelly.jQuery('#' + Namespace + ' ' + '.Forecast');
	
	if (Forecast)
	{
		var Forecast_Value_Element = Jelly.jQuery('#' + Namespace + ' ' + '.Forecast .Value');
		Forecast_Value_Element.html(Forecast);	

		Forecast_Element.addClass('Show');

		if (Donations || Volunteers)
			Forecast_Element.addClass('Show_Hint');
		else
			Forecast_Element.removeClass('Show_Hint');
	}
	else
	{
		Forecast_Element.removeClass('Show')
		Forecast_Element.removeClass('Show_Hint')
	}
};